import apiRequestor from './apiRequestor'
import authTokenRenewer from './authTokenRenewer'
import authTokenSessionStorageSaver from './authTokenSessionStorageSaver'
import authTokenValidator from './authTokenValidator'
import camelizer from './camelizer'
import generatePassword from './generatePassword'
import sessionStorageCleaner from './sessionStorageCleaner'
import validateRut from './validateRut'
import validateCompanyRut from './validateCompanyRut'
import validateEntityRut from './validateEntityRut'
import base64Decoder from "./base64Decoder";
import formTypeValidator from './formTypeValidator'
import validateCuiPeru from './validateCuiPeru'
import validateRucEntity from './validateRucEntity'
import getReportFileName from './getReportFileName'
import formatNumber from './formatNumber'
import {
  prepareCountriesForTenantSelectIso,
  prepareCountriesForTenantSelectAdmin,
  uniqCountriesByField,
} from './countriesSelect'

export const apiRequestorHelper = apiRequestor
export const authTokenRenewerHelper = authTokenRenewer
export const authTokenSessionStorageSaverHelper = authTokenSessionStorageSaver
export const authTokenValidatorHelper = authTokenValidator
export const camelizerHelper = camelizer
export const generatePasswordHelper = generatePassword
export const sessionStorageCleanerHelper = sessionStorageCleaner
export const validateRutHelper = validateRut
export const validateCompanyRutHelper = validateCompanyRut
export const validateEntityRutHelper = validateEntityRut
export const base64DecoderHelper = base64Decoder
export const formTypeValidatorHelper = formTypeValidator
export const validateRucHelper = validateCuiPeru
export const validateRucEntityHelper = validateRucEntity
export const getReportFileNameHelper = getReportFileName
export const formatNumberHelper = formatNumber
export const prepareCountriesForTenantSelectIsoHelper = prepareCountriesForTenantSelectIso
export const prepareCountriesForTenantSelectAdminHelper = prepareCountriesForTenantSelectAdmin
export const uniqCountriesByFieldHelper = uniqCountriesByField

